"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeSheetTransport = exports.ShiftQuery = exports.AdminShiftUpdateInput = exports.AdminShiftCreateInput = exports.ShiftTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
exports.ShiftTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    profileID: typebox_1.Type.String({ format: 'uuid' }),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    date: typebox_1.Type.String({ format: 'date' }),
    inTime: typebox_1.Type.String({ format: 'date-time' }),
    outTime: typebox_1.Type.Optional(typebox_1.Type.String({
        format: 'date-time',
        description: 'Will be undefined if the shift is still in progress. May not be the same day as the shift date in the case of a night shift.',
    })),
    adjustedInTime: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    adjustedOutTime: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    rejected: typebox_1.Type.Boolean(),
    rejectedBy: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    rejectedAt: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    metadata: common_1.MetaData,
});
exports.AdminShiftCreateInput = typebox_1.Type.Object({
    profileID: typebox_1.Type.String({ format: 'uuid' }),
    date: typebox_1.Type.String({ format: 'date' }),
    adjustedInTime: typebox_1.Type.String({ format: 'date-time' }),
    adjustedOutTime: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
});
exports.AdminShiftUpdateInput = typebox_1.Type.Object({
    adjustedInTime: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    adjustedOutTime: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
});
exports.ShiftQuery = typebox_1.Type.Partial(typebox_1.Type.Object({
    limit: typebox_1.Type.Integer({ minimum: 1, maximum: 100 }),
    offset: typebox_1.Type.Integer({ minimum: 0 }),
    profileID: typebox_1.Type.String({ format: 'uuid' }),
    rejected: typebox_1.Type.Boolean(),
    date: typebox_1.Type.String({ format: 'date' }),
    calenderWeekOf: typebox_1.Type.String({
        format: 'date',
        description: 'A date in the week in question. Only used for Time sheet',
    }),
}));
exports.TimeSheetTransport = typebox_1.Type.Object({
    startDate: typebox_1.Type.String({
        format: 'date',
        description: 'Start date of the week in question (will always be a Sunday)',
    }),
    calenderWeek: typebox_1.Type.Integer({
        minimum: 1,
    }),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    employees: typebox_1.Type.Array(typebox_1.Type.Object({
        profileID: typebox_1.Type.String({ format: 'uuid' }),
        shifts: typebox_1.Type.Array(exports.ShiftTransport),
        totalApprovedHours: typebox_1.Type.Number(),
        days: typebox_1.Type.Object({
            sunday: typebox_1.Type.Number({
                minimum: 0,
            }),
            monday: typebox_1.Type.Number({
                minimum: 0,
            }),
            tuesday: typebox_1.Type.Number({
                minimum: 0,
            }),
            wednesday: typebox_1.Type.Number({
                minimum: 0,
            }),
            thursday: typebox_1.Type.Number({
                minimum: 0,
            }),
            friday: typebox_1.Type.Number({
                minimum: 0,
            }),
            saturday: typebox_1.Type.Number({
                minimum: 0,
            }),
        }),
    })),
});
//# sourceMappingURL=shift-transport.js.map